import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL ?? ''
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''

if (!url || !anonKey) {
  throw new Error(
    'Supabase is niet geconfigureerd. Zet VITE_SUPABASE_URL en VITE_SUPABASE_ANON_KEY in .env (lokaal) of in Vercel → Settings → Environment Variables, en deploy opnieuw.'
  )
}

export const supabase = createClient(url, anonKey)

/** Private Realtime-broadcast vereist JWT voor autorisatie (RLS op realtime.messages). */
void supabase.auth.getSession().then(({ data: { session } }) => {
  void supabase.realtime.setAuth(session?.access_token ?? null)
})

/** Standaard salonId – bij meerdere salons uit config/route halen */
export const DEFAULT_SALON_ID = 'default'
